import { ATSelectionTile } from 'components/common/beacon/beaconRegistration';
import React from 'react';
import { IExternalAccount } from 'src/api/atv/atvApi.types';
import { getAccountTypeDisplayName } from 'utils/accountTypeUtils';
import { getHolderFullNames } from 'utils/accountUtils';
import { TransferTypeValue } from 'utils/constants';
import { formatCurrency } from 'utils/numberUtils';
import { ICurrencyBalance, IExternalAccountState } from '../../transferSlice.types';
import AccountDetails from './AccountDetails';

const AccountList = ({
  className,
  accounts,
  selectedAccountId,
  selectedExternalAccount,
  handleSelectAccountType,
  handleSelectTransferType,
  transferType,
  title,
}: {
  className?: string;
  accounts: IExternalAccount[];
  selectedAccountId: number;
  selectedExternalAccount: IExternalAccountState | null;
  handleSelectAccountType: (params: {
    selectedAccountType: string;
    selectedId: number;
    noAccounts: boolean;
    institutionName: string;
    accountNumber: string;
    balance: ICurrencyBalance;
    holderFullNames: string[];
    missingFields: string[];
  }) => void;
  handleSelectTransferType: (type: TransferTypeValue) => void;
  transferType: TransferTypeValue;
  title: string;
}) => {
  return (
    <div className={className}>
      <span className="b-grid-item--full-col b-xs:12-col b-sm:12-col b-md:12-col b-lg:12-col">
        <label className="b-typography-sans-serif--headline--100 b-font-weight-bold">
          {title}
        </label>
      </span>
      {accounts?.map((account: IExternalAccount) => (
        <div
          data-testid="accounts-container"
          className="accounts-container"
          key={account.id}
        >
          <div className="b-grid account-title">
            <div className="b-grid-item--full-col b-xs:12-col b-sm:12-col b-md:6-col b-lg:6-col">
              <ATSelectionTile
                className={
                  !account.isTransferEligible
                    ? 'disabled beacon-on-light b-color-background--0'
                    : ''
                }
              >
                <label
                  className="selection-label"
                  slot="label"
                  htmlFor={'account_' + account.id}
                >
                  {getAccountTypeDisplayName(account.accountType)} -{' '}
                  {account.balance
                    ? formatCurrency(account.balance.amount, account.balance.currency)
                    : ''}
                </label>
                <input
                  className={
                    !account.isTransferEligible
                      ? 'beacon-on-light b-color-background--0'
                      : ''
                  }
                  type="radio"
                  id={'account_' + account.id}
                  name="selection"
                  disabled={!account.isTransferEligible}
                  checked={
                    account.id === selectedAccountId &&
                    !selectedExternalAccount?.noAccounts
                  }
                  onChange={() =>
                    handleSelectAccountType({
                      selectedAccountType: account.accountType,
                      selectedId: account.id,
                      noAccounts: false,
                      institutionName: account.institutionName,
                      accountNumber: account.accountNumber,
                      balance: account.balance,
                      holderFullNames: getHolderFullNames(account.holder),
                      missingFields: account.missingFields || [],
                    })
                  }
                />
              </ATSelectionTile>
            </div>
          </div>
          {account.id === selectedAccountId && (
            <AccountDetails
              account={account}
              handleSelectTransferType={handleSelectTransferType}
              transferType={transferType}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default AccountList;
